import type { Cols, FieldRowable } from '../../common'

/**
 * Jaron, 2026-11-02 (Monday 13449508948): "No need for notes on the camera".
 * CCTV Cameras and WiFi Camera rows stop showing Notes in the app.
 */
const APP_CAMERA_DETAIL_FIELDS: readonly FieldRowable[] = [
  'security_cams_detail',
  'security_wifi_cameras_detail',
]

/**
 * The columns a row DRAWS, never the columns it holds: `row.notes` is still
 * stored and still filled in by useRowable when the product changes, because
 * `efficiencyToCalculator` copies it into `<section>_notes`, which Job Summary,
 * the Scope of Work and the contracts print. Hiding it here must not change them
 * (V106). The web keeps the column.
 */
export const rowColsToDraw = (
  cols: Cols,
  field: FieldRowable,
  isMobile: boolean,
): Cols =>
  isMobile && APP_CAMERA_DETAIL_FIELDS.includes(field)
    ? cols.filter((col) => col.type !== 'notes-input')
    : cols
